export default "__VITE_ASSET__tjFzy$dW__"